import { Component, OnInit } from "@angular/core";
import { TicketpaymentService } from "../ticket-payment/ticketpayment.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ManagePayersListModalComponent } from "@foh/publicpages/ticket-management/manage-payers-list-modal/manage-payers-list-modal.component";
import {
  NgbModal,
  ModalDismissReasons,
  NgbActiveModal
} from "@ng-bootstrap/ng-bootstrap";
import { confirmWithHtml, success, error } from "@foh/shared/data/sweet-alerts";
import { Globals } from "@foh/globals";

@Component({
  selector: "app-creditcards-management",
  templateUrl: "./creditcards-management.component.html",
  styleUrls: ["./creditcards-management.component.scss"]
})
export class CreditcardsManagementComponent implements OnInit {
  choosedMethod: any = null;
  currentStep: string;
  invalidUrlMsg: string;
  routeObs$: any;
  token: any;
  list: any = [];
  availableList: any = [];
  ticketsCats: any;
  venue: any;
  totalTickets: any;
  totalPrice: any;
  totalAddedPrice: any;
  totalRemainingPrice: any;
  currentSelectedPayer: any = null;
  currentChoosenTickets: any = null;
  groups: any = [];
  groupsWithLink: any = [];
  foundBefore: boolean = false;
  loading: boolean = true;
  invalidUrlError: boolean = false;
  createLoading: boolean = false;
  deleteLoading: boolean = false;
  imageSrc: string = null;
  splitMethod: string = "equal";
  totalNumberOfSelectedPayerToSplit: number = 0;
  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private ticketpaymentService: TicketpaymentService,
    private globals: Globals,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.routeObs$ = this.activeRoute.params.subscribe(params => {
      this.token = params["token"];
      this.retrieve();
    });
  }

  retrieve() {
    this.ticketpaymentService.retrieveTickets({ token: this.token }).subscribe(
      (response: any) => {
        this.loading = false;
        this.processRetrieveTicketResponse(response);
      },
      (error: any) => {
        this.loading = false;
        this.invalidUrlError = true;
        this.invalidUrlMsg = error.error.message;
      }
    );
  }

  processRetrieveTicketResponse(response) {
    if (response.foundBefore) {
      this.foundBefore = true;
      if (response.list.length == 1) {
        //Single payment
        window.location.href =
          response.paymentLink + response.list[0].referencecode;
      }
      return this.initStep4Directly(response);
    }
    this.showStep1();
    this.list = response.list;
    this.venue = response.venue;
    this.ticketsCats = response.ticketsCats;
    this.imageSrc = this.globals.UPLOADS + "logos/" + response.metaData.logo;
    this.injectTicketCats();
    this.totalTickets = this.list.length;
    this.totalPrice = this.calculateTotalPrice();
  }

  initStep4Directly(response) {
    this.imageSrc = this.globals.UPLOADS + "logos/" + response.metaData.logo;
    this.prepareLinks(response);
    this.showLinksStep();
  }

  prepareLinks(response) {
    this.groupsWithLink = [];
    for (var i = 0; i < response.list.length; i++) {
      var payer = this.getTicketById(
        response.list[i].ticket_id,
        response.tickets
      );

      var link = response.paymentLink + response.list[i].referencecode;
      this.groupsWithLink.push({
        payer: payer,
        link: link,
        total: response.list[i].amount
      });
    }
  }

  getTicketById(id, ticketsList) {
    for (var i = 0; i < ticketsList.length; i++) {
      if (ticketsList[i].id == id) {
        return ticketsList[i];
      }
    }
    return false;
  }

  getPaysFor(paysFor, ticketsList) {
    var finalArray = [];
    var arrayOfPaysFor = paysFor.split(";");
    for (var i = 0; i < arrayOfPaysFor.length; i++) {
      var ticket = this.getTicketById(arrayOfPaysFor[i], ticketsList);
      finalArray.push(ticket);
    }
    return finalArray;
  }

  setPaymentType(type) {
    this.choosedMethod = type;

    if (type == "group") {
      this.resetAll();
      this.refreshAvailableTicketsList();
      this.showSplitStep();
    } else {
      if (type == "all") {
        //Navigate To Payment as single
        this.createFullList();
        this.generateSingleLinkAndForceRedirect();
        return;
      }
      if (type == "seperate") {
        this.createIndividualList();
      }
      this.showPreviewStep();
    }
  }

  addGroupsAndShowPreviewStep() {
    this.createSplitList();
    this.refreshCounters();
    this.showSelectSplitTypeStep();
  }

  resetToStep1() {
    this.resetAll();
    this.showStep1();
  }

  backOneStepFromConfirmation() {
    if (this.choosedMethod == "group") {
      this.showSplitStep();
      return;
    }
    this.showStep1();
    return;
  }

  showStep1() {
    this.currentStep = "1";
  }

  showSplitStep() {
    this.refreshTotalCalculations();
    this.currentStep = "2";
  }
  showSelectSplitTypeStep() {
    this.currentStep = "2.1";
  }
  showPreviewStep() {
    this.currentStep = "3";
  }
  showLinksStep() {
    this.currentStep = "4";
  }

  injectTicketCats() {
    for (var i = 0; i < this.list.length; i++) {
      var ticketCat = this.getTicketCatById(this.list[i].ticketcat_id);
      this.list[i].ticketName = ticketCat.name;
      this.list[i].ticketPrice = ticketCat.price;
      this.list[i].selected = this.list[i].host ? true : false;
      this.list[i].readonly = this.list[i].host ? true : false;
      this.list[i].amount = 0;
    }
  }
  getTicketCatById(id) {
    for (var i = 0; i < this.ticketsCats.length; i++) {
      if (this.ticketsCats[i].id == id) {
        return this.ticketsCats[i];
      }
    }
    return null;
  }

  resetCurrentPayer() {
    this.currentSelectedPayer = null;
    this.currentChoosenTickets = [];
  }

  selectCurrentPayer(ticket) {
    this.currentSelectedPayer = ticket;
    this.openGroupSelectModal();
  }

  saveGroup(total) {
    //var injectedArray = this.detailedArrayOfPaysFor(ids);
    //var total = this.totalForGroup(injectedArray);
    if (total > this.totalRemainingPrice) {
      total = this.totalRemainingPrice;
    }
    this.groups.push({
      payer: this.currentSelectedPayer,
      total: total
    });

    this.resetCurrentPayer();
    this.refreshAvailableTicketsList();
    this.refreshTotalCalculations();
    //this.autoDetectLastItem();
  }

  autoDetectLastItem() {
    if (this.availableList.length != 1) {
      return;
    }
    this.currentSelectedPayer = this.availableList[0];
    this.saveGroup(this.totalRemainingPrice);
  }

  onRemoveGroup(index) {
    this.groups.splice(index, 1);
    this.refreshAvailableTicketsList();
    this.refreshTotalCalculations();
  }

  refreshAvailableTicketsList() {
    this.availableList = [];
    for (var i = 0; i < this.list.length; i++) {
      if (this.isTicketAddedBefore(this.list[i].id)) {
        continue;
      }
      this.availableList.push(this.list[i]);
    }
  }

  isTicketAddedBefore(ticketId) {
    for (var i = 0; i < this.groups.length; i++) {
      if (this.groups[i].payer.id == ticketId) {
        return true;
      }
    }
    return false;
  }

  detailedArrayOfPaysFor(ids) {
    var array = [];
    for (var j = 0; j < ids.length; j++) {
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].id == ids[j]) {
          array.push(this.list[i]);
        }
      }
    }
    return array;
  }

  totalForGroup(array) {
    var total = 0;
    for (var i = 0; i < array.length; i++) {
      total += array[i].ticketPrice;
    }
    return total;
  }

  createFullList() {
    this.groups = [];
    var payFor = [];
    var payForInjected = [];
    var total = 0;
    var indexOfHost = 0;

    for (var i = 0; i < this.list.length; i++) {
      // payFor.push(this.list[i].id);
      // payForInjected.push(this.list[i]);
      total += this.list[i].ticketPrice;
      if (this.list[i].host) {
        indexOfHost = i;
      }
    }
    this.groups.push({
      payer: this.list[indexOfHost],
      total: total,
      issplit: false,
      ishost:true
    });
    this.resetCurrentPayer();
    this.refreshAvailableTicketsList();
    this.refreshTotalCalculations();
  }

  createIndividualList() {
    this.groups = [];

    for (var i = 0; i < this.list.length; i++) {
      // var payFor = [];
      // var payForInjected = [];
      // payFor.push(this.list[i].id);
      // payForInjected.push(this.list[i]);
      this.groups.push({
        payer: this.list[i],
        total: this.totalPrice / this.list.length
      });
    }
    this.resetCurrentPayer();
    this.refreshAvailableTicketsList();
    this.refreshTotalCalculations();
  }

  createSplitList() {
    this.groups = [];
    for (var i = 0; i < this.list.length; i++) {
      if (this.list[i].selected) {
        this.groups.push({
          payer: this.list[i],
          total: this.list[i].amount,
          issplit: true,
          ishost:this.list[i].host
        });
      }
    }
  }

  generateSingleLinkAndForceRedirect() {
    this.loading = true;
    var finalGroup = this.prepareGroupObjectForSubmit();
    this.ticketpaymentService
      .createTicketsGroup({ token: this.token, group: finalGroup })
      .subscribe(
        (response: any) => {
          this.loading = false;
          var link: any = false;
          for (var i = 0; i < response.list.length; i++) {
            link = response.paymentLink + response.list[i].referencecode;
            break;
          }
          if (link !== false) {
            window.location.href = link;
          }
        },
        error => {
          this.createLoading = false;
        }
      );
  }

  generateLinks() {
    this.createLoading = true;
    var finalGroup = this.prepareGroupObjectForSubmit();
    this.ticketpaymentService
      .createTicketsGroup({ token: this.token, group: finalGroup })
      .subscribe(
        (response: any) => {
          this.createLoading = false;
          this.foundBefore = true;
          this.initStep4Directly(response);
        },
        error => {
          this.createLoading = false;
        }
      );
  }

  prepareGroupObjectForSubmit() {
    var array = [];
    for (var i = 0; i < this.groups.length; i++) {
      array.push({
        payerid: this.groups[i].payer.id,
        amount: this.groups[i].total,
        issplit: this.groups[i].issplit,
        ishost: this.groups[i].ishost,
      });
    }
    return array;
  }

  resetAll() {
    this.groups = [];
    this.resetCurrentPayer();
  }

  openGroupSelectModal() {
    const modalRef = this.modalService.open(ManagePayersListModalComponent, {
      windowClass: "foh-modal"
    });
    modalRef.componentInstance.currentSelectedPayer = this.currentSelectedPayer;
    modalRef.componentInstance.availableList = this.availableList;
    modalRef.componentInstance.total = this.totalRemainingPrice;
    modalRef.componentInstance.save.subscribe(total => {
      this.saveGroup(total);
      modalRef.componentInstance.activeModal.dismiss("Saved");
    });
  }

  confirmDeleteGroup() {
    confirmWithHtml(
      "Reset & Delete Created Group",
      "Are you sure you want to reset & re-create the groups? This will invalidate created payment links"
    ).then(confirm => {
      if (confirm.value == true) {
        this.deleteGroup();
      }
    });
  }

  deleteGroup() {
    this.deleteLoading = true;
    this.ticketpaymentService
      .deleteTicketsGroup({ token: this.token })
      .subscribe(
        (response: any) => {
          this.deleteLoading = false;
          success(
            "Created Groups are deleted",
            "Please create new groups in order to generate new payment links."
          );
          this.processRetrieveTicketResponse(response);
        },
        error => {
          this.deleteLoading = false;
        }
      );
  }

  calculateTotalPrice() {
    var total = 0;
    for (var i = 0; i < this.list.length; i++) {
      total += this.list[i].ticketPrice;
    }
    return total;
  }

  refreshTotalCalculations() {
    this.totalAddedPrice = this._calculateTotalAddedprice();
    this.totalRemainingPrice = this._calculateTotalRemainingprice(
      this.totalAddedPrice
    );
  }

  _calculateTotalAddedprice() {
    var totalAddedPrice = 0;
    for (var i = 0; i < this.groups.length; i++) {
      totalAddedPrice += parseFloat(this.groups[i].total);
    }
    return totalAddedPrice;
  }

  _calculateTotalRemainingprice(totalAddedPrice) {
    return this.totalPrice - totalAddedPrice;
  }

  onChangeSplitType() {
    this.refreshCounters();
  }

  onAmountChange(ticket) {
    if (ticket.total == "" || ticket.total == null || ticket.total < 0) {
      ticket.total = 0;
    }
    // var totalAddedPrice = this._calculateTotalAddedprice() - ticket.amount;
    // var totalRemainingPrice = this._calculateTotalRemainingprice(totalAddedPrice);
    // var newAmount = parseFloat(ticket.amount);
    // if (newAmount > totalRemainingPrice) {
    //   ticket.amount = totalRemainingPrice;
    // }
    this.refreshTotalCalculations();
  }

  onCheckBoxChange(ticket) {
    this.refreshCounters();
    this.calculateNumberofSelectedPayers();
  }

  calculateNumberofSelectedPayers() {
    var total = 0;
    for (var i = 0; i < this.list.length; i++) {
      if (this.list[i].selected) {
        total++;
      }
    }
    this.totalNumberOfSelectedPayerToSplit = total;
  }

  refreshCounters() {
    if (this.splitMethod == "equal") {
      this._divideAmountEqually();
    }
    this._resetUnselectedPayer();
    this.refreshTotalCalculations();
  }

  _divideAmountEqually() {
    var totalNumberOfChecked = this._numberOfCheckedList();
    var amountPerCheckedPayer = this.totalPrice / totalNumberOfChecked;
    for (var i = 0; i < this.groups.length; i++) {
      this.groups[i].total = amountPerCheckedPayer;
    }
  }

  _numberOfCheckedList() {
    var totalNumberOfChecked = 0;
    for (var i = 0; i < this.list.length; i++) {
      if (this.list[i].selected) {
        totalNumberOfChecked++;
      }
    }
    return totalNumberOfChecked;
  }

  _resetUnselectedPayer() {
    for (var i = 0; i < this.list.length; i++) {
      if (!this.list[i].selected) {
        this.list[i].amount = 0;
      }
    }
  }

  selectEqualSplit() {
    this.splitMethod = "equal";
    this.onChangeSplitType();
  }
  selectCustomSplit() {
    this.splitMethod = "custom";
    this.onChangeSplitType();
  }
}
